import { GatewayRead, INetworkInterface, IWirelessNetworkInterface } from '@ncss/models';

export type InterfaceType = 'eth' | 'wlan' | 'ppp';

export enum StatusCode {
  SYNC_START = 1,
  SYNC_PROGRESS = 2,
  SYNC_STOPPED = 3,
  SYNC_FAILED = 4,
}

export enum WifiSignalStrength {
  POOR = 1,
  FAIR = 2,
  EXCELLENT = 3,
}

export interface WifiNetwork {
  name: string;
  signal: WifiSignalStrength;
  secure: boolean;
}

export interface DirectConnectGateway {
  loading: boolean;
  read: GatewayRead | undefined;
  remoteTarget: { host: string; port: number } | undefined;
  availableNetworks: WifiNetwork[];
  syncStatus: StatusCode | undefined;
  syncProgress: number | undefined;
  forcingCellular: boolean | undefined;
  partying?: boolean | undefined;
  powerLedColor: string;
  programmedLedColor: string;
  rfLedColor: string;
  cellularLedColor: string;
  requestInfo(): void;
  party(enable: boolean): Promise<boolean>;
  setForceCellular(force: boolean): Promise<boolean>;
  setCellularEnabled(enabled: boolean): Promise<boolean>;
  setRemoteTarget(info: { host?: string; port?: number }): Promise<{ host?: string; port?: number } | undefined>;
  changeNetwork(
    interfaceType: InterfaceType,
    netInterface: IWirelessNetworkInterface | INetworkInterface
  ): Promise<IWirelessNetworkInterface | INetworkInterface | undefined>;
  changeWifiNetwork(ssid: string, password?: string): Promise<boolean>;
  forgetWifiNetwork(): Promise<boolean>;
  forceSync(): Promise<{ success: boolean }>;
}
